import { sortByNameOf } from '@pubstack/common/src/sort'
import { ScopeUser } from '@pubstack/common/src/user'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const USER_QUERY_KEYS = ['users']
const url = '/users'
const byNickname = sortByNameOf<ScopeUser>((user) => user.nickname)
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useUsers = () => {
  const queryResult = useQuery<ScopeUser[]>({
    url,
    keys: USER_QUERY_KEYS,
    select: byNickname,
  })
  return { ...queryResult, data: queryResult.data || [] }
}
//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateUser = (toasts: MutationToasts = {}) => {
  return useMutation<ScopeUser>({
    method: 'post',
    url,
    collectionKeys: USER_QUERY_KEYS,
    ...toasts,
  })
}
export const useDeleteUser = (id: string, toasts: MutationToasts = {}) => {
  return useMutation<void>({
    method: 'delete',
    url: `${url}/${id}`,
    collectionKeys: USER_QUERY_KEYS,
    resourceId: id,
    ...toasts,
  })
}

export const useEditUser = (id: string, toasts: MutationToasts = {}) => {
  return useMutation<ScopeUser>({
    method: 'put',
    url: `${url}/${id}`,
    collectionKeys: USER_QUERY_KEYS,
    resourceId: id,
    ...toasts,
  })
}
